import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getLocalStorageItem } from '../../utils/safeStorage';
import { API_BASE_URL } from '../../services/apiRegistry';

const FullBleedImg = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

/**
 * Coach banner per CRS handoff: only fetch when `hasBannerImage` is true;
 * GET .../player/coaches/:id/banner via BFF. Parent: position relative + gradient fallback.
 */
export default function CoachBannerImage({ coachId, hasBannerImage = false }) {
  const [blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    let revoked = false;
    let objectUrl = null;

    const token = getLocalStorageItem('token');
    if (!coachId || !token || !hasBannerImage) {
      setBlobUrl(null);
      return () => {};
    }

    fetch(`${API_BASE_URL}/crs/coaches/${coachId}/banner`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => (r.ok ? r.blob() : null))
      .then((blob) => {
        if (revoked || !blob) return;
        objectUrl = URL.createObjectURL(blob);
        setBlobUrl(objectUrl);
      })
      .catch(() => {
        if (!revoked) setBlobUrl(null);
      });

    return () => {
      revoked = true;
      if (objectUrl && objectUrl.startsWith('blob:')) URL.revokeObjectURL(objectUrl);
    };
  }, [coachId, hasBannerImage]);

  if (!blobUrl) return null;

  return <FullBleedImg src={blobUrl} alt="" />;
}
